export default {
  read: {
    title: "Calendario de eventos",
    subtitle: "Crea evento, cursos o formaciones en el calendario",
    createNewBtn: "Nuevo evento",
    search: {
      placeholder: "Buscar evento"
    },
    notifications: {
      deleted: "Evento eliminado con éxito"
    },
    design: {
      button: "Diseño",
      modal: {
        title: "Diseño",
        section: "Eventos",
        form: {
          title: "Titulo",
          labels: {
            title: "Titulo",
            subtitle: "Subtitulo",
            color: "Color"
          },
          save: "Guardar"
        }
      }
    },
    deleteModal: {
      title: "Eliminar evento",
      subtitle:
        "¿Estás seguro de que quieres eliminar este evento? Esta acción no se puede deshacer."
    }
  },
  create: {
    title: "Nuevo evento",
    subtitle:
      "Configura aquí tu proyecto. Para cualquier duda o consulta contacta con tu asesor.",
    generalForm: {
      title: "General",
      mainImg: "Imagen principal",
      images: {
        label: "Imágenes",
        add: "Añadir imagen"
      },
      name: "Nombre",
      description: "Descripción",
      type: "Tipo",
      typeOptions: {
        onsite: "Presencial",
        online: "Online"
      },
      status: "Estado",
      statusOptions: {
        enabled: "Activo",
        disabled: "Inactivo"
      }
    },
    dateForm: {
      title: "Fechas",
      startInscription: "Inicio de inscripciones",
      endInscription: "Fin de inscripciones",
      startEvent: "Inicio del evento",
      endEvent: "Fin del evento",
      recurrent: {
        label: "¿Es recurrente?",
        under: "Evento recurrente"
      }
    },
    locationForm: {
      title: "Acceso / Ubicación",
      link: "Link del acceso",
      location: "Añade la URL de acceso o localización"
    },
    ratesForm: {
      add: "Añadir tarifa",
      title: "Tarifas",
      amount: "Cantidad",
      cost: "Precio",
      name: "Nombre",
      rateTable: "Tabla de tarifas",
      delete: ""
    },
    notifications: {
      createdEvent: "Evento creado con éxito",
      editedEvent: "Evento actualizado con éxito",
      removedEvent: "Evento eliminado con éxito"
    },
    highlight: {
      label: "Destacar evento",
      under: "Evento destacado"
    }
  }
};
